<portal-dropdown-menu [tooltip]="'datatable.optionalColumns' | translate">
  <div class="dropdown-header">{{ 'datatable.optionalColumns' | portalTranslate }}</div>

  @for (column of optionalColumns; track column) {
    <button class="dropdown-item" (click)="toggleColumn(column.name)" type="button">
      <i
        class="far"
        [ngClass]="{
          'fa-check-square': column.visible,
          'fa-square': !column.visible,
        }"
      ></i>
      <ng-container *portalTransclusion="transclusions; name: 'action'; context: { column }">
        {{ column.name }}
      </ng-container>
    </button>
  }
</portal-dropdown-menu>
